export default "__VITE_ASSET__21FjwXo9__"